import { chartTableFlatTransformer } from '@/utils/reports/chartTableFlatTransformer';
import { getPercentage } from './tableUtils';

const tableWithTotal = (data) => {
  const hires_total = data?.reduce((acc, curr) => acc + curr?.hires, 0);

  function innerFunc(data) {
    if (!data?.length) return [];
    return data.map((datum) => {
      return {
        ...datum,

        hires_total,
        hires_per: getPercentage(datum?.hires, hires_total),
        subRows: innerFunc(datum?.subRows),
      };
    });
  }

  return innerFunc(data);
};

export const hiresTableTransformer = ({ response, args }) => {
  // Safely extract properties from response
  const { chart = [], headers, lookups, table = [] } = response || {};
  const { dt, g1, g2 } = lookups || {}; // Lookup mappings for data transformation

  const data = g1?.length || g2?.length ? table : chart;
  const headerKey = g1?.length ? 'g1' : 'dt';

  const { group_by_1, group_by_2 } = args || {};

  // Transform raw chart data into a flat structure
  const transformedData = chartTableFlatTransformer({
    headerKey,
    headers,
    data,
    g1,
    g2,
    dt,
    g1Key: group_by_1?.id || group_by_1,
    g2Key: group_by_2?.id || group_by_2,
  });

  const tableData = tableWithTotal(transformedData);

  return tableData;
};
